module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ul', {
    staticClass: "el-upload-list el-upload-list--picture"
  }, _vm._l((_vm.fileList), function(file) {
    return _c('li', {
      staticClass: "el-upload-list__item"
    }, [_c('a', {
      attrs: {
        "href": _vm.imgService + file.filename,
        "target": "_blank"
      }
    }, [_c('img', {
      staticClass: "el-upload-list__item-thumbnail",
      attrs: {
        "src": _vm.imgService + file.filename,
        "alt": ""
      }
    })]), _vm._v(" "), _c('a', {
      staticClass: "el-upload-list__item-name"
    }, [_c('el-button', {
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.handleDelete(file)
        }
      }
    }, [_vm._v("Delete")])], 1)])
  }), 0), _vm._v(" "), _c('el-upload', {
    ref: "imageupload",
    attrs: {
      "action": _vm.importEndpoint,
      "headers": _vm.rootConfig.headers,
      "before-upload": _vm.beforeUpload,
      "show-file-list": false,
      "multiple": true,
      "on-success": _vm.handleUploadSuccess,
      "on-error": _vm.handleUploadError,
      "on-change": _vm.handleChange,
      "list-type": "picture"
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_vm._v("Click to upload")]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("\n            jpg/png files with a size less than 5000kb\n        ")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c2243ce"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/fields/ImageUpload.vue
// module id = 544
// module chunks = 1